import { render, staticRenderFns } from "./AdditionalMetaproperties.vue?vue&type=template&id=5d38382c&scoped=true"
import script from "./AdditionalMetaproperties.vue?vue&type=script&lang=js"
export * from "./AdditionalMetaproperties.vue?vue&type=script&lang=js"
import style0 from "./AdditionalMetaproperties.vue?vue&type=style&index=0&id=5d38382c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d38382c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d38382c')) {
      api.createRecord('5d38382c', component.options)
    } else {
      api.reload('5d38382c', component.options)
    }
    module.hot.accept("./AdditionalMetaproperties.vue?vue&type=template&id=5d38382c&scoped=true", function () {
      api.rerender('5d38382c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/bynder/AdditionalMetaproperties.vue"
export default component.exports